module.exports = __webpack_public_path__ + "img/history5.6ef909e7.jpg";